GameView    = require "views/base/game"
Picker = require("views/components/picker")

class NumberPickerView extends GameView
  template: require("./template")

  events:
    "iostap .btn-done": "endGame"

  serialize: ->
    data = super

    { title, number, answer } = data
    { prefix, suffix } = number

    if /\W#+\W/.test(title)
      bits = title.split(/\W+#+\W+/)
    else
      num = "#{prefix}#{answer.value}#{suffix}"
      num = num?.replace /[\$\!]/g, (w) -> "\\" + w
      splitter = new RegExp "\\s+#{num}\\s+"
      bits = (title or "").split(splitter)

    data.isLong = prefix?.length + suffix?.length > 5
    data.before = bits[0]
    data.after  = bits.slice(1).join("")

    data

  show: ->
    super
    @isPickerClicked = false
    @timeout = 0
    @$el.find(".content-fill").addClass("invisible")

    @setEl @findAll(".number-picker"), "pickers"

    { initial, digits } = @options.data.number

    initial = " #{initial}" while "#{initial}".length < digits

    @pickers =
      for el, i in @getEl("pickers")
        picker = new Picker
          el: el
          value: +"#{initial}".charAt(i)

        @listenTo picker, "change", @onChange
        picker

    @onChange(picker, null, true) for picker in @pickers

    @enterGame()

    debouncedOnResize = _.debounce (=> @onResize()), 100
    $(window).on "resize.numberPickerView", debouncedOnResize

    @onResize()

  onChange: (picker, diff, isFirstRun) ->  
    isIncreasing = diff > 0
    isDecreasing = diff < 0
    @isPickerClicked = (isIncreasing || isDecreasing) unless @isPickerClicked
    @getTotal()
    @setState("touched") if @isPickerClicked

    if isFirstRun
      @transform picker.scroller,
        y: picker.offset.height * -picker.value
        transition: "all 300ms"

    else if (picker.value is 0) and isIncreasing
      @transform picker.scroller,
        y: picker.offset.height * -10
        transition: "all 300ms"

      cascade = 1

    else
      if (picker.value is 1) and isIncreasing
        reset = 0

      if (picker.value is 9) and isDecreasing
        reset = picker.offset.height * -10
        cascade = -1

      if reset?
        @transform picker.scroller,
          y: reset
          transition: "none"

        picker.scroller.offsetWidth

      @transform picker.scroller,
        y: picker.offset.height * -picker.value
        transition: "all 300ms"

    if cascade?
      @cascadeFrom(picker, cascade)
  
  onResize: =>
    if @$el.hasClass("visible") then @$el.removeClass("visible")
    if @resizeTimeout
      window.clearTimeout @resizeTimeout

    @resizeTimeout = window.setTimeout ( =>
      @$el.find(".content-fill").removeClass("invisible")
      for picker in @pickers
        picker.getOffset()
        picker.setBy(0)
      @$el.addClass("visible")
      @timeout = 300
    ), @timeout

  getTotal: ->
    @currentValue = +(picker.value for picker in @pickers).join("")
    for picker, i in @pickers
      diff = Math.pow(10, @pickers.length - i - 1)
      picker.toggleUp(@currentValue + diff > @options.data.number.max)
      picker.toggleDown(@currentValue - diff < @options.data.number.min)

  cascadeFrom: (picker, diff) ->
    index = @pickers.indexOf(picker)
    @pickers[index - 1]?.setBy(diff)

  isCorrect: ->
    @currentValue is @options.data.answer.value

  endGame: ->
    super

    @submit()

  answerDetails: ->
    questions    = @options.metadata?.questions or []

    return [] unless questions.length > 0

    question         = questions[0]
    correct          = @isCorrect()
    value            = parseInt(@currentValue)

    cleanedContent =
      question.question.content.replace(/##/, '__').replace(/<br>/, ' ')
    question.question.content = cleanedContent

    answer           = _.find question.answers, (a) -> a.correct is correct
    details          = question: question.question, answer: answer

    details.answer.content = value

    [ details ]

  hide: ->
    super
    $(window).off "resize.numberPickerView"

module.exports = NumberPickerView
